<template>
    <div>
        <el-upload
            ref="imageUploader"
            :action="uploadImageUrl"
            :data="data"
            accept="image/*"
            :on-success="uploadSuccess"
            style="display: none;"
            >
            <div slot="trigger" ref="imageUploaderBtn" >上传图片</div>
        </el-upload>
        <el-upload
            ref="videoUploader"
            :action="uploadVideoUrl"
            :data="data"
            accept="video/*"
            :on-success="uploadSuccess"
            style="display: none;"
        >
            <div slot="trigger" ref="videoUploaderBtn" >上传视频</div>
        </el-upload>
        <!-- <quill-editor
            v-model="html"
            ref="contentEditor"
            :style="editorStyle"
            :options="editorOptions"
            @change="onEditorChange($event)"
        >
        </quill-editor> -->

    </div>
</template>

<script>
import Vue from 'vue'
// import VueQuillEditor from 'vue-quill-editor';
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';

// Quill.register('modules/ImageResize', ImageResize);
// Vue.use(VueQuillEditor);

const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
    ["blockquote", "code-block"], // 引用  代码块
    [{ header: 1 }, { header: 2 }], // 1、2 级标题
    [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
    [{ script: "sub" }, { script: "super" }], // 上标/下标
    [{ indent: "-1" }, { indent: "+1" }], // 缩进
    // [{'direction': 'rtl'}],                         // 文本方向
    [{ size: ["small", false, "large", "huge"] }], // 字体大小
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
    [{ font: [] }], // 字体种类
    [{ align: [] }], // 对齐方式
    ["clean"], // 清除文本格式
    ["link", "image", 'video'] // 链接、图片、视频
];
//上传图片和视频参考：https://github.com/surmon-china/vue-quill-editor/issues/102
export default {
    name: "ExcelEditor",
    props: {
        content: String,
        uploadData: {
            type: Object,
            default: function ()
            {
                return {};
            }
        },
        uploadImageUrl: {
            type: String,
            default: '/media/upload/image'
        },
        uploadVideoUrl: {
            type: String,
            default: '/media/upload/video'
        },
        editorStyle: {
            type: String,
            default: ''
        },
        toolbarOptions: {
            type: Array,
            default: toolbarOptions
        }
    },
    data()
    {
        return {
            uploadMediaType: '',
            html: this.content,
            data: this.uploadData,
            editorOptions:
            {
                placeholder: '请输入内容',
                theme:'snow',
                modules:
                {
                    toolbar:
                    {
                        container: this.toolbarOptions,
                        handlers: {
                            image: (value)=>
                            {
                                // console.log('this.addRange:',this.$refs.contentEditor.quill.getSelection());
                                this.uploadMediaType = 'image';
                                this.$refs.imageUploaderBtn.click();
                            },
                            video: (value)=>
                            {
                                // console.log('this.addRange:',this.$refs.contentEditor.quill.getSelection());
                                this.uploadMediaType = 'video';
                                this.$refs.videoUploaderBtn.click();
                            }
                        }
                    },
                    ImageResize:
                    {
                        modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
                    },
                }
            },
        }
    },
    methods: {
        onEditorChange({ quill, html, text }) {
            this.$emit('update:content', html);
        },
        uploadSuccess(response, file, fileList)
        {
            console.log('uploadSuccess', response, file);
            if(!response || !response.data || !response.data.path || !this.uploadMediaType) return;
            let range = this.$refs.contentEditor.quill.getSelection();
            let index = range != null ? range.index : 0;
            let length = range != null ? range.length : 0;
            if(length)
            {
                this.$refs.contentEditor.quill.deleteText(index, length, Quill.sources.USER);
            }
            this.$refs.contentEditor.quill.insertEmbed(index, this.uploadMediaType, response.data.path, Quill.sources.USER);
            this.$refs.contentEditor.quill.setSelection(index+1, 0);
            this.$refs.imageUploader.clearFiles();
            this.$refs.videoUploader.clearFiles();
            this.uploadMediaType = '';
        },
        getText(index=0, length)
        {
            return this.$refs.contentEditor.quill.getText(index, length);
        }
    },
    watch: {
        content(content)
        {
            this.html = content;
        },
        uploadData(data)
        {
            this.data = data;
        }
    },
    mounted()
    {
    }
}
</script>

<style scoped>

</style>
<style>
    .editor {
        line-height: normal !important;
        height: 800px;
    }
    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }
    .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg
    {
        transform: translateY(-7px);
    }
    .ql-snow .ql-picker .ql-picker-label::before{
        position: absolute;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>



// WEBPACK FOOTER //
// src/components/editor/ExcelEditor.vue